import { ArrowUpRight } from "lucide-react";
import { INSTAGRAM } from "../../lib/site-data";
import InstagramMark from "./InstagramMark";

/** "Stay connected on Instagram" profile card — shared by /apply success + Community Guidelines. */
export default function InstagramProfileCard({ testid = "instagram-profile-card", className = "" }) {
  return (
    <div className={className}>
      <div className="text-[11px] uppercase tracking-[0.24em] text-black/50 font-semibold">
        Stay connected on Instagram
      </div>
      <a
        href={INSTAGRAM.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className="group mt-4 inline-flex items-center gap-4 rounded-2xl border border-black/10 hover:border-[#C837AB]/40 bg-white hover:bg-[#FAFAFA] px-5 py-4 transition-all duration-300"
      >
        <InstagramMark size={44} />
        <div className="text-left">
          <div className="text-[10px] uppercase tracking-[0.2em] text-black/45 font-semibold">
            Instagram
          </div>
          <div className="font-display mt-0.5 text-lg font-semibold tracking-tight">
            {INSTAGRAM.handle}
          </div>
        </div>
        <ArrowUpRight className="w-4 h-4 text-orange-600 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform ml-1" />
      </a>
    </div>
  );
}
